import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import {
  faHeart,
  faTrash,
  faEdit,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from "react-bootstrap-sweetalert";
import Header from "../../components/Header";
import LoadingScreen from "../components/LoadingScreen";

class WeddingEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      namesuami: "",
      nameistri: "",
      wedding: [],
      undangan: [],
      panggilan: "",
      fullname: "",
      editId: "",
      editPanggilan: "",
      editFullname: "",
      isReady: false,
      alert: null,
      message: "",
      errors: [],
    };
    this.handleUpdateUndangan = this.handleUpdateUndangan.bind(this);
    this.handleCreateUndangan = this.handleCreateUndangan.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.hasErrorFor = this.hasErrorFor.bind(this);
    this.renderErrorFor = this.renderErrorFor.bind(this);
  }

  componentDidMount() {
    const wedUsername = this.props.match.params.username;
    axios
      .get(`${window.localhost}/wedding/getuser/${wedUsername}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        this.setState({
          username: response.data.username,
          namesuami: response.data.namesuami,
          nameistri: response.data.nameistri,
          wedding: response.data,
        });
      })
      .catch((error) => {
        console.log(error.response.data);
        this.props.history.push("/admin-wedding/login");
      });
    // Undangan
    axios
      .get(`${window.localhost}/undangan/${wedUsername}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        this.setState({
          undangan: response.data,
          isReady: true,
        });
      })
      .catch((error) => {
        console.log(error.response.data);
        this.props.history.push("/admin-wedding/login");
      });
  }

  handleFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleEdit = (id, panggilan, fullname) => {
    this.setState({
      editId: id,
      editPanggilan: panggilan,
      editFullname: fullname,
    });
  };

  handleUpdateUndangan(event) {
    event.preventDefault();

    const formData = new FormData();
    formData.append("editPanggilan", this.state.editPanggilan);
    formData.append("editFullname", this.state.editFullname);

    axios
      .post(`${window.localhost}/undangan/${this.state.editId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          return this.goToHome();
        }
      })
      .catch((error) => {
        // console.log(error.response.data);
        this.setState({
          errors: error.response.data,
        });
      });
  }

  handleCreateUndangan(event) {
    event.preventDefault();

    const formData = new FormData();
    formData.append("username", this.state.username);
    formData.append("panggilan", this.state.panggilan);
    formData.append("fullname", this.state.fullname);

    axios
      .post(`${window.localhost}/undangan`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          return this.goToHome();
        }
      })
      .catch((error) => {
        // console.log(error.response.data);
        this.setState({
          errors: error.response.data,
        });
      });
  }

  confirmDelete(id, panggilan) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Hapus Deh"
        cancelBtnText="Nggak Jadi"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu ..."
        onConfirm={() => this.deleteItem(id)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Yakin ingin menghapus <b>{panggilan}</b> dari daftar?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  deleteItem(id) {
    axios
      .delete(`${window.localhost}/undangan/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg == true) {
          this.hideAlert();
          this.goToHome();
        }
      });
  }

  goToHome() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        {this.state.message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.componentDidMount();
    this.hideAlert();
  }

  hideAlert() {
    this.setState({
      alert: null,
      errors: [],
      panggilan: "",
      fullname: "",
    });
  }

  hasErrorFor = (field) => {
    return !!this.state.errors[field];
  };

  renderErrorFor(field) {
    if (this.hasErrorFor(field)) {
      return (
        <span className="invalid-feedback">
          <strong>{this.state.errors[field][0]}</strong>
        </span>
      );
    }
  }

  render() {
    const { undangan, wedding } = this.state;
    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div className="bg-white">
          <Header />
          <div className="container-fluid pt-6 overflow-hidden">
            <div className="container my-4 py-3">
              <h2 className="fw-bold text-center">
                <div className="grey-line me-2"> </div>
                {this.state.namesuami}
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                {this.state.nameistri}
                <div className="grey-line ms-2"> </div>
              </h2>
              <hr />

              <div className="container rounded-4 p-3 p-sm-4">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">No.</th>
                        <th scope="col">Nama Panggilan</th>
                        <th scope="col">Nama Lengkap</th>
                        <th scope="col">Permalink</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {undangan.map((undgn, i) => (
                        <tr key={i}>
                          <th scope="row">{i + 1}</th>
                          <td>{undgn.panggilan}</td>
                          <td>{undgn.fullname}</td>
                          <td>/{undgn.permalink}</td>
                          <td>
                            <div class="btn-group btn-group-sm" role="group">
                              <button
                                className="btn btn-danger"
                                onClick={() =>
                                  this.confirmDelete(undgn.id, undgn.panggilan)
                                }
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>

                              <button
                                className="btn btn-warning"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                                onClick={() =>
                                  this.handleEdit(
                                    undgn.id,
                                    undgn.panggilan,
                                    undgn.fullname
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </button>

                              <Link
                                to={`/${wedding.template}/${wedding.username}/${undgn.permalink}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-primary"
                              >
                                <FontAwesomeIcon icon={faExternalLinkAlt} />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <hr />
                <h3 className="my-4">Tambah Undangan</h3>
                <form onSubmit={this.handleCreateUndangan}>
                  <div className="row row-cols-md-2 row-cols-1 mb-3">
                    <div className="col">
                      <label htmlFor="panggilan" className="form-label">
                        Nama Panggilan
                      </label>
                      <input
                        type="text"
                        id="panggilan"
                        name="panggilan"
                        value={this.state.panggilan}
                        className={`form-control ${
                          this.hasErrorFor("panggilan") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("panggilan")}
                    </div>
                    <div className="col">
                      <label htmlFor="fullname" className="form-label">
                        Nama Lengkap
                      </label>
                      <input
                        type="text"
                        id="fullname"
                        name="fullname"
                        value={this.state.fullname}
                        className={`form-control ${
                          this.hasErrorFor("fullname") ? "is-invalid" : ""
                        }`}
                        onChange={this.handleFieldChange}
                      />
                      {this.renderErrorFor("fullname")}
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary me-3 px-4">
                    Tambah
                  </button>
                  <Link to={`/admin-wedding/index`} className="btn btn-light">
                    Kembali
                  </Link>
                </form>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Edit {this.state.editPanggilan}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={this.handleUpdateUndangan}>
                    <div className="row row-cols-md-2 row-cols-1 mb-3">
                      <div className="col">
                        <label htmlFor="editPanggilan" className="form-label">
                          Nama Panggilan
                        </label>
                        <input
                          type="text"
                          id="editPanggilan"
                          name="editPanggilan"
                          value={this.state.editPanggilan}
                          className={`form-control ${
                            this.hasErrorFor("editPanggilan")
                              ? "is-invalid"
                              : ""
                          }`}
                          onChange={this.handleFieldChange}
                        />
                        {this.renderErrorFor("editPanggilan")}
                      </div>
                      <div className="col">
                        <label htmlFor="fullname" className="form-label">
                          Nama Lengkap
                        </label>
                        <input
                          type="text"
                          id="fullname"
                          name="fullname"
                          value={this.state.editFullname}
                          className={`form-control ${
                            this.hasErrorFor("fullname") ? "is-invalid" : ""
                          }`}
                          onChange={this.handleFieldChange}
                        />
                        {this.renderErrorFor("fullname")}
                      </div>
                    </div>

                    <button type="submit" className="btn btn-primary me-3 px-4">
                      Simpan
                    </button>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {this.state.alert}
        </div>
      );
    }
  }
}

export default WeddingEdit;
